const UserReducer = (state, action) => {
    switch (action.type) {

        case "GET_USERS_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "GET_USERS_SUCCESS":
            return {
                ...state,
                users: action.payload,
                isFetching: false,
                error: false,
                hasFetched: true,
            };

        case "GET_USERS_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
                hasFetched: false,
            };

        case "UPDATE_USER_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "UPDATE_USER_SUCCESS":
            return {
                ...state,
                users: state.users.map((user) =>
                    user._id === action.payload._id
                        ? action.payload
                        : user
                ),
                isFetching: false,
                error: false,
            };

        case "UPDATE_USER_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
            };

        default:
            return state;
    }
};

export default UserReducer;